import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { ROUTE } from '../constant/route.constant';

@Injectable({ providedIn: 'root' })
export class ESignGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const { QUERY_PARAM } = ROUTE.E_SIGN;

    const token = route.queryParamMap.get(QUERY_PARAM.TOKEN);

    if (!token) {
      return this.router.createUrlTree([ROUTE.ERROR.MAIN, ROUTE.ERROR.FORBIDDEN]);
    }

    return true;
  }
}
